import { AxiosResponse } from 'axios'
import $api from '../http'

// Public price sources of the Costs section (ticket 6ad5d51d). All anonymous: the section
// sits under the login form. Credit packages are read through PaymentService.getPackages,
// the same call as the recharging station, so the two lists cannot disagree.
export default class CostsService {
  // Plans, demo and modules with their price (digiscan-web services/price_list.py).
  static async getPriceList(): Promise<AxiosResponse> {
    return $api.get('/payments/price-list')
  }

  // Rate card in credits per hour (routes/billing/usage.py::public_rates).
  static async getRates(): Promise<AxiosResponse> {
    return $api.get('/billing/rates')
  }
}
